export const LLM_PROVIDERS = {
  OPENAI: 'openai',
  ANTHROPIC: 'anthropic',
  GROQ: 'groq',
};

export const DEFAULT_LLM_CONFIG = {
  temperature: 0.7,
  max_tokens: 16384,
  top_p: null,
  frequency_penalty: null,
  presence_penalty: null,
  top_k: null,
  seed: null,
  stop: null,
};

export const OPENAI_CONFIG = {
  temperature: 0.7,
  max_tokens: 16384,
  top_p: 1.0,
  frequency_penalty: 0.1,
  presence_penalty: 0.1,
};

export const ANTHROPIC_CONFIG = {
  temperature: 0.7,
  max_tokens: 16384,
};

export const GROQ_CONFIG = {
  temperature: 0.7,
  max_tokens: 16384,
  top_p: 0.95,
};

export const OPENAI_MODELS_CONFIG = {
  'gpt-5.1': {
    displayName: 'GPT-5.1',
    contextWindow: 256000,
    maxOutput: 32768,
    defaultParams: { temperature: 0.7, max_tokens: 32768, top_p: 1.0 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 32768 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
  'gpt-5': {
    displayName: 'GPT-5',
    contextWindow: 256000,
    maxOutput: 32768,
    defaultParams: { temperature: 0.7, max_tokens: 32768, top_p: 1.0 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 32768 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
  'o3': {
    displayName: 'O3',
    contextWindow: 200000,
    maxOutput: 100000,
    defaultParams: { max_tokens: 8192 },
    paramLimits: {
      max_tokens: { min: 1, max: 100000 },
      reasoning_effort: { options: ['low', 'medium', 'high'] },
    },
    supports: ['max_tokens', 'reasoning_effort'],
    not_supports: ['temperature', 'top_p', 'frequency_penalty', 'presence_penalty', 'seed', 'stop'],
  },
  'o3-mini': {
    displayName: 'O3 Mini',
    contextWindow: 128000,
    maxOutput: 65536,
    defaultParams: { max_tokens: 4096 },
    paramLimits: {
      max_tokens: { min: 1, max: 65536 },
      reasoning_effort: { options: ['low', 'medium', 'high'] },
    },
    supports: ['max_tokens', 'reasoning_effort'],
    not_supports: ['temperature', 'top_p', 'frequency_penalty', 'presence_penalty', 'seed', 'stop'],
  },
  'o1': {
    displayName: 'O1',
    contextWindow: 200000,
    maxOutput: 100000,
    defaultParams: { max_tokens: 8192 },
    paramLimits: {
      max_tokens: { min: 1, max: 100000 },
      reasoning_effort: { options: ['low', 'medium', 'high'] },
    },
    supports: ['max_tokens', 'reasoning_effort'],
    not_supports: ['temperature', 'top_p', 'frequency_penalty', 'presence_penalty', 'seed', 'stop'],
  },
  'o1-mini': {
    displayName: 'O1 Mini',
    contextWindow: 128000,
    maxOutput: 65536,
    defaultParams: { max_tokens: 4096 },
    paramLimits: {
      max_tokens: { min: 1, max: 65536 },
      reasoning_effort: { options: ['low', 'medium', 'high'] },
    },
    supports: ['max_tokens', 'reasoning_effort'],
    not_supports: ['temperature', 'top_p', 'frequency_penalty', 'presence_penalty', 'seed', 'stop'],
  },
  'gpt-4o': {
    displayName: 'GPT-4o',
    contextWindow: 128000,
    maxOutput: 16384,
    defaultParams: { temperature: 0.7, max_tokens: 16384, top_p: 1.0, frequency_penalty: 0.1, presence_penalty: 0.1 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 16384 },
      top_p: { min: 0.0, max: 1.0 },
      frequency_penalty: { min: -2.0, max: 2.0 },
      presence_penalty: { min: -2.0, max: 2.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'frequency_penalty', 'presence_penalty', 'seed', 'stop'],
    not_supports: [],
  },
  'gpt-4o-mini': {
    displayName: 'GPT-4o Mini',
    contextWindow: 128000,
    maxOutput: 16384,
    defaultParams: { temperature: 0.7, max_tokens: 16384, top_p: 1.0, frequency_penalty: 0.1, presence_penalty: 0.1 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 16384 },
      top_p: { min: 0.0, max: 1.0 },
      frequency_penalty: { min: -2.0, max: 2.0 },
      presence_penalty: { min: -2.0, max: 2.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'frequency_penalty', 'presence_penalty', 'seed', 'stop'],
    not_supports: [],
  },
  'gpt-4.1-2025-04-14': {
    displayName: 'GPT-4.1',
    contextWindow: 128000,
    maxOutput: 32768,
    defaultParams: { temperature: 0.7, max_tokens: 32768, top_p: 1.0 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 32768 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
  'gpt-4.1-mini-2025-04-14': {
    displayName: 'GPT-4.1 Mini',
    contextWindow: 128000,
    maxOutput: 32768,
    defaultParams: { temperature: 0.7, max_tokens: 32768, top_p: 1.0 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 32768 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
};

export const ANTHROPIC_MODELS_CONFIG = {
  'claude-opus-4-5-20251101': {
    displayName: 'Claude Opus 4.5',
    contextWindow: 200000,
    maxOutput: 16384,
    defaultParams: { temperature: 0.7, max_tokens: 16384 },
    paramLimits: {
      temperature: { min: 0.0, max: 1.0 },
      max_tokens: { min: 1, max: 16384 },
    },
    supports: ['temperature', 'max_tokens', 'stop_sequences'],
    not_supports: ['top_p', 'top_k', 'frequency_penalty', 'presence_penalty', 'seed'],
  },
  'claude-sonnet-4-5-20250929': {
    displayName: 'Claude Sonnet 4.5',
    contextWindow: 200000,
    maxOutput: 16384,
    defaultParams: { temperature: 0.7, max_tokens: 16384 },
    paramLimits: {
      temperature: { min: 0.0, max: 1.0 },
      max_tokens: { min: 1, max: 16384 },
    },
    supports: ['temperature', 'max_tokens', 'stop_sequences'],
    not_supports: ['top_p', 'top_k', 'frequency_penalty', 'presence_penalty', 'seed'],
  },
  'claude-sonnet-4-20250514': {
    displayName: 'Claude Sonnet 4',
    contextWindow: 200000,
    maxOutput: 16384,
    defaultParams: { temperature: 0.7, max_tokens: 16384 },
    paramLimits: {
      temperature: { min: 0.0, max: 1.0 },
      max_tokens: { min: 1, max: 16384 },
    },
    supports: ['temperature', 'max_tokens', 'stop_sequences'],
    not_supports: ['top_p', 'top_k', 'frequency_penalty', 'presence_penalty', 'seed'],
  },
  'claude-3-7-sonnet-20250219': {
    displayName: 'Claude 3.7 Sonnet',
    contextWindow: 200000,
    maxOutput: 16384,
    defaultParams: { temperature: 0.7, max_tokens: 16384 },
    paramLimits: {
      temperature: { min: 0.0, max: 1.0 },
      max_tokens: { min: 1, max: 16384 },
    },
    supports: ['temperature', 'max_tokens', 'stop_sequences'],
    not_supports: ['top_p', 'top_k', 'frequency_penalty', 'presence_penalty', 'seed'],
  },
  'claude-3-5-sonnet-20241022': {
    displayName: 'Claude 3.5 Sonnet',
    contextWindow: 200000,
    maxOutput: 8192,
    defaultParams: { temperature: 0.7, max_tokens: 8192 },
    paramLimits: {
      temperature: { min: 0.0, max: 1.0 },
      max_tokens: { min: 1, max: 8192 },
    },
    supports: ['temperature', 'max_tokens', 'stop_sequences'],
    not_supports: ['top_p', 'top_k', 'frequency_penalty', 'presence_penalty', 'seed'],
  },
  'claude-3-5-haiku-20241022': {
    displayName: 'Claude 3.5 Haiku',
    contextWindow: 200000,
    maxOutput: 8192,
    defaultParams: { temperature: 0.7, max_tokens: 8192 },
    paramLimits: {
      temperature: { min: 0.0, max: 1.0 },
      max_tokens: { min: 1, max: 8192 },
    },
    supports: ['temperature', 'max_tokens', 'stop_sequences'],
    not_supports: ['top_p', 'top_k', 'frequency_penalty', 'presence_penalty', 'seed'],
  },
  'claude-haiku-4-5-20251001': {
    displayName: 'Claude Haiku 4.5',
    contextWindow: 200000,
    maxOutput: 16384,
    defaultParams: { temperature: 0.7, max_tokens: 16384 },
    paramLimits: {
      temperature: { min: 0.0, max: 1.0 },
      max_tokens: { min: 1, max: 16384 },
    },
    supports: ['temperature', 'max_tokens', 'stop_sequences'],
    not_supports: ['top_p', 'top_k', 'frequency_penalty', 'presence_penalty', 'seed'],
  },
};

export const GROQ_MODELS_CONFIG = {
  'meta-llama/llama-4-maverick-17b-128e-instruct': {
    displayName: 'Llama 4 Maverick',
    contextWindow: 131072,
    maxOutput: 8192,
    defaultParams: { temperature: 0.7, max_tokens: 8192, top_p: 0.95 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 8192 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
  'meta-llama/llama-4-scout-17b-16e-instruct': {
    displayName: 'Llama 4 Scout',
    contextWindow: 131072,
    maxOutput: 8192,
    defaultParams: { temperature: 0.7, max_tokens: 8192, top_p: 0.95 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 8192 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
  'llama-3.3-70b-versatile': {
    displayName: 'Llama 3.3 70B Versatile',
    contextWindow: 131072,
    maxOutput: 32768,
    defaultParams: { temperature: 0.7, max_tokens: 16384, top_p: 0.95 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 32768 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
  'meta-llama/llama-3.1-8b-instant': {
    displayName: 'Llama 3.1 8B Instant',
    contextWindow: 131072,
    maxOutput: 8192,
    defaultParams: { temperature: 0.7, max_tokens: 8192, top_p: 0.95 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 8192 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
  'qwen3-32b': {
    displayName: 'Qwen 3 32B',
    contextWindow: 131072,
    maxOutput: 16384,
    defaultParams: { temperature: 0.7, max_tokens: 8192, top_p: 0.95 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 16384 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
  'deepseek-r1-distill-llama-70b': {
    displayName: 'DeepSeek R1 70B',
    contextWindow: 131072,
    maxOutput: 16384,
    defaultParams: { temperature: 0.7, max_tokens: 8192, top_p: 0.95 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 16384 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
  'mixtral-8x7b-32768': {
    displayName: 'Mixtral 8x7B',
    contextWindow: 32768,
    maxOutput: 8192,
    defaultParams: { temperature: 0.7, max_tokens: 8192, top_p: 0.95 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 8192 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
  'gemma2-9b-it': {
    displayName: 'Gemma 2 9B',
    contextWindow: 8192,
    maxOutput: 4096,
    defaultParams: { temperature: 0.7, max_tokens: 4096, top_p: 0.95 },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 4096 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  },
};

export const getProviderFromModel = (model) => {
  if (OPENAI_MODELS_CONFIG[model]) return LLM_PROVIDERS.OPENAI;
  if (ANTHROPIC_MODELS_CONFIG[model]) return LLM_PROVIDERS.ANTHROPIC;
  if (GROQ_MODELS_CONFIG[model]) return LLM_PROVIDERS.GROQ;
  
  if (model?.startsWith('gpt-') || model?.startsWith('o1') || model?.startsWith('o3')) return LLM_PROVIDERS.OPENAI;
  if (model?.startsWith('claude-')) return LLM_PROVIDERS.ANTHROPIC;
  return LLM_PROVIDERS.GROQ;
};

export const getModelConfig = (model) => {
  if (OPENAI_MODELS_CONFIG[model]) return OPENAI_MODELS_CONFIG[model];
  if (ANTHROPIC_MODELS_CONFIG[model]) return ANTHROPIC_MODELS_CONFIG[model];
  if (GROQ_MODELS_CONFIG[model]) return GROQ_MODELS_CONFIG[model];
  
  const provider = getProviderFromModel(model);
  if (provider === LLM_PROVIDERS.OPENAI) {
    return {
      displayName: model,
      contextWindow: 128000,
      maxOutput: 16384,
      defaultParams: { ...OPENAI_CONFIG },
      paramLimits: {
        temperature: { min: 0.0, max: 2.0 },
        max_tokens: { min: 1, max: 16384 },
        top_p: { min: 0.0, max: 1.0 },
        frequency_penalty: { min: -2.0, max: 2.0 },
        presence_penalty: { min: -2.0, max: 2.0 },
      },
      supports: ['temperature', 'max_tokens', 'top_p', 'frequency_penalty', 'presence_penalty', 'seed', 'stop'],
      not_supports: [],
    };
  }
  if (provider === LLM_PROVIDERS.ANTHROPIC) {
  return {
    displayName: model,
    contextWindow: 200000,
    maxOutput: 16384,
    defaultParams: { ...ANTHROPIC_CONFIG },
    paramLimits: {
      temperature: { min: 0.0, max: 1.0 },
      max_tokens: { min: 1, max: 16384 },
    },
    supports: ['temperature', 'max_tokens', 'stop_sequences'],
    not_supports: ['top_p', 'top_k', 'frequency_penalty', 'presence_penalty', 'seed'],
  };
  }
  return {
    displayName: model,
    contextWindow: 131072,
    maxOutput: 16384,
    defaultParams: { ...GROQ_CONFIG },
    paramLimits: {
      temperature: { min: 0.0, max: 2.0 },
      max_tokens: { min: 1, max: 16384 },
      top_p: { min: 0.0, max: 1.0 },
    },
    supports: ['temperature', 'max_tokens', 'top_p', 'stop'],
    not_supports: ['frequency_penalty', 'presence_penalty', 'seed'],
  };
};

export const getDefaultLLMConfig = (model) => {
  const config = getModelConfig(model);
  return {
    model,
    ...config.defaultParams,
  };
};

export const buildLLMConfig = (model, customParams = {}) => {
  const defaultConfig = getDefaultLLMConfig(model);
  const cleanParams = Object.fromEntries(
    Object.entries(customParams).filter(([_, v]) => v !== null && v !== undefined && v !== '')
  );
  return {
    ...defaultConfig,
    ...cleanParams,
    model,
  };
};

export const getParamLimits = (model, param) => {
  const config = getModelConfig(model);
  return config.paramLimits?.[param] || null;
};

export const isParamSupported = (model, param) => {
  const config = getModelConfig(model);
  return config.supports?.includes(param) || false;
};

export const validateParam = (model, param, value) => {
  const limits = getParamLimits(model, param);
  if (!limits) return true;
  if (value < limits.min) return false;
  if (value > limits.max) return false;
  return true;
};

export const isReasoningModel = (model) => {
  return ['o1', 'o1-mini', 'o3', 'o3-mini'].includes(model);
};
